// extracted by mini-css-extract-plugin
export default {"button":"CTAButton_button__E-hh+","arrow":"CTAButton_arrow__xZ5e1","small":"CTAButton_small__ZMxSC","secondary":"CTAButton_secondary__vr9j9"};